// extracted by mini-css-extract-plugin
export default {"container":"style_container__tXmQn","pageHeader":"style_pageHeader__nCN-4","formControl":"style_formControl__KUDJU","label":"style_label__mcRMD"};